import { createContext, useCallback, useContext, useMemo, useState } from 'react'

const ModalContext = createContext()

// Global, cross-cutting modal orchestration. Any component can open a modal by
// key with an optional props payload; modals are kept in a stack so they can be
// layered (e.g. a confirm dialog on top of a form).
export function ModalProvider({ children }) {
  const [stack, setStack] = useState([])

  const openModal = useCallback((key, props = {}) => {
    setStack((prev) => [...prev, { key, props }])
  }, [])

  const closeModal = useCallback(() => {
    setStack((prev) => prev.slice(0, -1))
  }, [])

  const closeAll = useCallback(() => setStack([]), [])

  const value = useMemo(
    () => ({ stack, openModal, closeModal, closeAll }),
    [stack, openModal, closeModal, closeAll]
  )

  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
}

export function useModal() {
  return useContext(ModalContext)
}
